import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from '../../models/menu-item.model';

@Component({
  selector: 'app-horizontal-menu-item',
  imports: [],
  templateUrl: './horizontal-menu-item.component.html',
  styleUrl: './horizontal-menu-item.component.scss'
})
export class HorizontalMenuItemComponent {
  @Input({ required: true }) item!: MenuItem;
  @Input() active = false;
  @Input() tone: 'default' | 'stocks' | 'magenta' | 'green' = 'default';
  @Output() selected = new EventEmitter<void>();

  protected onClick(event: Event): void {
    event.preventDefault();
    if (this.item.disabled) {
      return;
    }
    this.selected.emit();
  }
}
